export const inputFieldContent = {
    'dari': {
        'Email Address': 'ایمیل آدرس',
        'Enter email address': 'ایمیل آدرس را وارد کنید',
        'Password': 'رمز عبور(پسورد)',
        'Enter password': 'رمز عبور را وارد کنید',
        "New Password": "رمز عبور جدید",
        "Confirm Password": "رمز عبور را تایید کنید",
        "Enter new password": "رمز عبور جدید را وارد کنید",
        "Re-enter new password": "رمز عبور مجدد را دوباره وارد کنید",
        "Reason": "دلیل",
        "Enter the reason": "دلیل خود را وارد کنید",
        "First Name": "نام",
        "Enter first name": "نام را وارد کنید",
        "Last Name": "نام خانوادگی",
        "Enter last name": "نام خانوادگی را وارد کنید",
        "Official Email Address": "آدرس ایمیل رسمی",
        "Enter official email address": "آدرس ایمیل رسمی را وارد کنید",
        "Phone Number": "شماره تلفون",
        "House No.": "شماره خانه",
        "Market/Block No.": "شماره بلاک/مارکیت",
        "Floor No.": "طبقه",
        "Street Name": "نام جاده",
        "Enter street name": "نام جاده را وارد نمایید",
        "City/Town": "شهر/شهرک",
        "Enter city/town": "شهر/شهرک را وارد کنید",
        "Country": "کشور",
        "Select country": "کشور را انتخاب کنید",
        "Province (State)": "ولایت (ایالت)",
        "Enter province (state)": "ولایت (ایالت) را انتخاب کنید",
        "Region": "منطقه",
        "Enter region": "منطقه را انتخاب کنید",
        "District": "ناحیه (ولسوالی)",
        "Enter district": "ناحیه (ولسوالی) را انتخاب کنید",
        "OTP has been sent to {{phone_or_email}}": "رمز عبور یک بار مصرف به ایمیل {{phone_or_email}} ارسال شد",
        "OTP Verification": "تایید رمز یکبار مصرف",
        "We have sent a code to {{email_or_phone}}": "یک رمز یکبار مصرف به {{email_or_phone}} ارسال شد",
        "Verify": "تایید نمایید",
        "Admin Added Successfully": "مدیر با موفقیت اضافه شد",
        "Date of Birth": "تاریخ تولد",
        "Select gender": `جنسیت نی تنلنگ`,
        "Gender": "جنسیت",
        "Nationality": "ملیت",
        "Select nationality": "ملیت را انتخاب کنید",
        "Profession": "حرفه",
        "Select profession": "حرفه را انتخاب کنید",
        "Secondary Phone Number": "تنها این کاربر",
        "Locate your Position": "توزیع‌کننده به همراه کاربران زیرمجموعه با موفقیت فعال شد",
        "Enter house no.": "توزیع‌کننده با موفقیت غیرفعال شد",
        "Enter market/block no.": "توزیع‌کننده اصلی با موفقیت غیرفعال شد",
        "Enter floor no.": "تمام توزیع کنندگان همراه با تمام کاربران زیر مجموعه با موفقبت غیر فعال شود، را انتخاب کنید.",
        "Business Assigned Area": "توزیع‌کننده به همراه کاربران زیرمجموعه با موفقیت غیرفعال شد",
        "Add (You can add 1 more business assigned area)": "نمایش معلومات توزیع‌کننده",
        "Passport": "پاسپورت",
        "National ID": "تذکره",
        "Passport Number": "شماره پاسپورت",
        "Enter passport number": "شماره پاسپورت را وارد کنید",
        "Valid From ": "درصد هزینه خدمات فعال ‌سازی بسته",
        "Valid Up To": "درصد هزینه خدمات کاربر اصلی",
        "Passport Front Page": "صفحه اول پاسپورت",
        "Basic Details": "آیا می‌خواهید این لیست را صادر (در خارج ذخیره)کنید؟",
        "Identification Details": "لیست شامل بیش از ۵۰۰۰ رکورد است و به ایمیل شما ارسال خواهد شد.",
        "Bank Details": "مشاهده معلومات مربوط به توزیع‌کننده",
        "Business Details": "توزیع‌کننده با موفقیت فعال شد",
        "Photo": "عکس",
        "Service Fee": "به همراه تمام کاربران زیرمجموعه",
        "‘Valid Up To’ should be greater than ‘Valid From’": `درصد کارمزد خدمات شارژ الکترونیکی کاربر زیرمجموعه`,
        "Nationality ID Number": "شماره تذکره",
        "Enter nationality id number": "شماره تذکره را وارد کنید"
    },
    'pashto': {
        "Email Address": 'برېښنالیک',
        "Enter email address": "برېښنالیک داخل کړئ",
        "Password": "پسورډ",
        "Enter password": "د پسورډ داخلول",
        "Forgot Password?": "پسورډ مو هېر شوی؟",
        "New Password": "نوی پسورډ",
        "Confirm Password": "د پسورډ تاییدول",
        "Enter new password": "نوی پسورډ د ننه کړئ",
        "Re-enter new password": "د نوي پسورډ بیا د ننه کول",
        "Reason": "دلیل",
        "Enter the reason": "خپل دلیل ولیکئ",
        "First Name": "نوم",
        "Enter first name": "نوم ولیکئ",
        "Last Name": "تخلص",
        "Enter last name": "تخلص ولیکئ",
        "Official Email Address": "رسمي برېښنالیک",
        "Enter official email address": "رسمي برېښنالیک ولیکئ",
        "Phone Number": "د ټېلېفون شمېره",
        "House No.": "د کور شمېره",
        "Market/Block No.": "د مارکېټ/بازار شمېره",
        "Floor No.": "د ګرده شمېره",
        "Street Name": "د سړک نوم",
        "Enter street name": "د سړک نوم ولیکئ",
        "City/Town": "ښارګوټی",
        "Enter city/town": "د ښارګوټي نوم ولیکئ",
        "Country": "هېواد",
        "Select country": "هېوادنی تنلنگ",
        "Province (State)": "ولایت",
        "Enter province (state)": "ولایت وټاکئ",
        "Region": "ساحه/زون",
        "Enter region": "ساحه/زون وټاکئ",
        "District": "ناحیه (ولسوالي)",
        "Enter district": "ناحیه (ولسوالي) وټاکئ",
        "OTP has been sent to {{phone_or_email}}": "یو ځل کارېدو وړ پسورډ {{phone_or_email}} برېښنالیک ته ولېږل شو",
        "OTP Verification": "د یو ځل کارېدونکي پسورډ تاییدول",
        "Verify": "تصدیق یې کړئ",
        "Admin Added Successfully": "مدیر (اډمېن) په بریالیتوب سره اضافه شو",
        "We have sent a code to {{email_or_phone}}": "کود {{email_or_phone}} برېښنالیک ته ولېږل شو",
        "Date of Birth": "د زیږون نیټه",
        "Select gender": `جنس وټاکئ`,
        "Gender": "جندر",
        "Nationality": "ملیت",
        "Select nationality": "تابعیت غوره کړئ",
        "Profession": "مسلک",
        "Select profession": "یو مسلک غوره کړئ",
        "Secondary Phone Number": "یوازې دا کاروونکی",
        "Locate your Position": "توزیع کوونکی له فرعي کاروونکو سره په بریالیتوب فعال شو",
        "Enter house no.": "توزیع کوونکی په بریالیتوب سره غیر فعال شو",
        "Enter market/block no.": "اصلي توزېع کوونکی په بریالیتوب سره غیر فعال شو",
        "Enter floor no.": "ټول توزېع کوونکي له ټولو فرعي کاروونکو سره په بریالیتوب غیر فعال شي، انتخاب کړئ",
        "Business Assigned Area": "توزېع کوونکی له فرعي کاروونکو سره په بریالیتوب غیر فعال شو",
        "Add (You can add 1 more business assigned area)": "د توزېع کوونکي د معلوماتو کتنه",
        "Passport": "پاسپورټ",
        "National ID": "پېژندپاڼه",
        "Passport Number": "د پاسپورټ شمیره",
        "Enter passport number": "د پاسپورټ شمیره دننه کړئ",
        "Valid From ": "د بنډل فعالولو د خدماتو د فیس سلنه",
        "Valid Up To": "د اصلي کاروونکي د خدماتو د فیس سلنه",
        "Passport Front Page": "د پاسپورټ لومړۍ پاڼه",
        "Basic Details": "ایا تاسو غواړئ دغه لېست صادر (بیرون ذخیره) کړئ؟",
        "Identification Details": "لېست تر ۵۰۰۰ ریکارډونو زیات دی او ستاسو ایمېل ته به ولېږل شي",
        "Bank Details": "د توزیع کوونکي د جزئیاتو کتنه",
        "Business Details": "توزیع کوونکی په بریالیتوب سره فعال شو",
        "Photo": "انځور",
        "Service Fee": "له ټولو فرعي کاروونکو سره",
        "Nationality ID Number": "پېژندپاڼه شمیره",
        "Enter nationality id number": "د پیژندنې شمیره دننه کړئ"
    },
    'uzbeki': {
        "Email Address": 'ایمیل آدرس',
        "Enter email address": "ایمیل آدرسینگیزنی کیریتینگ",
        "Password": "اوتیش سوز (پسورد)",
        "Enter password": "پسورد (اوتیش سوزنی) یازینگ",
        "New Password": "ینگی پسورد",
        "Confirm Password": "پسوردنی تصدیقلنگ",
        "Enter new password": "ینگی پسوردنی کیریتینگ",
        "Re-enter new password": "ینگی پسوردنی قیته کیریتینگ",
        "Reason": "دلیل",
        "Enter the reason": "دلیلینگیزنی یازینگ",
        "First Name": "آت",
        "Enter first name": "آتینگیزنی یازینگ",
        "Last Name": "عایله‌وی آت",
        "Enter last name": "عایله‌وی آتینگیزنی یازینگ",
        "Official Email Address": "رسمی ایمیل آدرس",
        "Enter official email address": "رسمی ایمیل آدرسنی یازینگ",
        "Phone Number": "تلفون رقمی",
        "House No.": "اوی رقمی",
        "Market/Block No.": "بلاک/ مارکیت شماره‌سی",
        "Floor No.": "قَوت/ طبقه",
        "Street Name": "جاده نینگ آتی",
        "Enter street name": "جاده‌نینگ آتینی یازینگ",
        "City/Town": "شهر/ شهرچه",
        "Enter city/town": "شهر/شهرچه‌نی یازینگ",
        "Country": "اولکه",
        "Select country": "اولکهنی تنلنگ",
        "Province (State)": "ولایت (ایالت)",
        "Enter province (state)": "ولایت (ایالت)نی تنلنگ",
        "Region": "منطقه",
        "Enter region": "منطقه‌نی تنلنگ",
        "District": "ناحیه (اولسواللیک)",
        "Enter district": "ناحیه‌ (اولسواللیک)نی تنلنگ",
        "OTP has been sent to {{phone_or_email}}": "ایمیل گه بیر مرته مصرف بوله دیگن رمز {{phone_or_email}} یوباریلدی",
        "OTP Verification": "بیر مرته‌لیک پسوردنی تیکشیریش",
        "Verify": "تصدیقلنگ",
        "Admin Added Successfully": "مدیر موفقیت بیلن قوشیلدی",
        "We have sent a code to {{email_or_phone}}": "ایمیل اوچون نظرده توتیلگن کد {{email_or_phone}} یوباریلدی",
        "Date of Birth": "توغیلگن ییل",
        "Select gender": `جنسیت نی تنلنگ`,
        "Gender": "جندر",
        "Nationality": "ملیت",
        "Select nationality": "ملیت نی تنلنگ",
        "Profession": "کسب - هنر",
        "Select profession": "کسب - هنرنی تنلنگ",
        "Secondary Phone Number": "شونچه که فایدلنتوچی",
        "Locate your Position": "توزیع قیلوچی و باله‌لر فایده‌لنووچیلری موفقیتلی فعاللشتیریلدی",
        "Enter house no.": "توزیع قیلوچی موفقیتلی اوچیریلدی",
        "Enter market/block no.": "اساسی توزیع قیلوچی موفقیتلی اوچیریلدی",
        "Enter floor no.": "موفقیتلی اوچیریلگن باله‌لر فایده‌لنووچیلر بیلن بیرگه‌ برچه توزیع قیلوچینی تنلنگ",
        "Business Assigned Area": "توزیع قیلوچیلر و باله‌لر فایده‌لنووچیلری موفقیتلی اوچیریلدی",
        "Add (You can add 1 more business assigned area)": "توزیع قیلوچیلر تفصیلاتلرینی آلدیندن کوریش",
        "Passport": "پاسپورت",
        "National ID": "تذکره",
        "Passport Number": "نمبر پاسپورت",
        "Enter passport number": "پاسپورت نمبرنی کیریتینگ",
        "Valid From ": "توپلمنی فعاللشتیریش خدمتی تولاوی فایزی",
        "Valid Up To": "آته-آنه‌ خدمتی تولاوی فایزی",
        "Passport Front Page": "پاسپتورت بیرینچی صفحه‌سی",
        "Basic Details": "رویخط نی صادر قیلماقچی سیز می؟",
        "Identification Details": "رویخط 5000 ته‌دن آشه‌دی وایمیلینگیزگه یوباریله‌دی",
        "Bank Details": "توزیع قیلوچی نینگ تفصیلاتینی کوریش",
        "Business Details": "توزیع قیلوچی موفقیت بیلن فعال قیلیندی",
        "Photo": "عکسلر",
        "Service Fee": "برچه باله لر فایده لنتوچیسی بیلن",
        "Nationality ID Number": "نمبر تذکره",
        "Enter nationality id number": "تذکره نمبرینی کیریتیش"

    }
}


